/** Idle time before typing flag reverts to false. */
export const TYPING_IDLE_MS = 3000;

/** Debounce before writing typing=true to Firestore. */
export const TYPING_SIGNAL_DEBOUNCE_MS = 400;

/** Cooldown after sending a message (public widget anti-spam). */
export const CHAT_SEND_COOLDOWN_MS = 2000;

/** Max characters per public chat message. */
export const CHAT_MESSAGE_MAX_LENGTH = 1000;

export const DEFAULT_TYPING_STATE = {
  publicUser: false,
  agent: false,
};

/**
 * @param {unknown} raw
 * @returns {{ publicUser: boolean, agent: boolean }}
 */
export function normalizeTypingState(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...DEFAULT_TYPING_STATE };
  }
  return {
    publicUser: raw.publicUser === true,
    agent: raw.agent === true,
  };
}

/**
 * Lightweight debounce (no lodash dependency).
 * @param {(...args: unknown[]) => void} fn
 * @param {number} waitMs
 */
export function debounce(fn, waitMs) {
  let timeoutId = null;
  const debounced = (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, waitMs);
  };
  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  return debounced;
}
